var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4848 6.78772V7.6362H25.303C24.2121 7.6362 23.1212 8.12105 22.3939 8.84832L8.93939 22.4241C8.21211 23.1514 7.72727 24.2423 7.72727 25.3332V72.1211H6.87878C4.57575 72.1211 2.75757 70.3029 2.75757 67.9998V6.78772C2.75757 4.48469 4.57575 2.6665 6.87878 2.6665H51.4848C53.6667 2.6665 55.4848 4.6059 55.4848 6.78772Z",
    stroke: "url(#paint0_linear_631_2659)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2727 77.0911H11.8485C9.54548 77.0911 7.72729 75.273 7.72729 72.9699V25.3336C7.72729 24.2427 8.21214 23.1518 8.93942 22.4245L22.5152 8.96993C23.2424 8.24266 24.3334 7.75781 25.4243 7.75781H56.4546C58.7576 7.75781 60.5758 9.57599 60.5758 11.879V39.273M32.697 67.879H16.9394M27.4849 60.6063H16.9394M24.3334 53.3336H16.9394M30.0303 46.0608H16.9394M25.9091 38.7881H16.9394M51.3637 38.7881H31.3637M36.3334 31.5154H16.9394M51.3637 31.5154H41.9091M51.3637 24.2427H33.5455M33.5455 16.9699H51.3637",
    stroke: "url(#paint1_linear_631_2659)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3031 7.75781V20.6063C25.3031 22.9093 23.4849 24.7275 21.1818 24.7275H7.72729",
    stroke: "url(#paint2_linear_631_2659)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3636 66.4243L41.7878 64.1213C42.6363 63.2728 42.7575 61.8182 41.909 60.9697C41.0605 60.1213 39.606 60 38.7575 60.8485L36.3333 63.1516C35.4848 64 35.3636 65.3334 36.212 66.3031C36.9393 67.2728 38.3939 67.394 39.3636 66.4243ZM40.9393 71.1516L46.1514 66.1819C46.9999 65.3334 47.1211 63.8788 46.2727 63.0303C45.4242 62.1819 43.9696 62.0606 43.1211 62.9091L37.909 67.8788C37.0605 68.7273 36.9393 70.1819 37.7878 71.0303C38.6363 71.8788 40.0908 72 40.9393 71.1516ZM45.5454 72.9697L47.9696 70.6667C48.8181 69.8182 48.9393 68.3637 48.0908 67.5152C47.2424 66.6667 45.7878 66.5455 44.9393 67.394L42.5151 69.697C41.6666 70.5455 41.5454 71.8788 42.3939 72.8485C43.1211 73.8182 44.5757 73.8182 45.5454 72.9697Z",
    stroke: "url(#paint3_linear_631_2659)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1818 54.4243L67.9697 65.3334C68.9394 66.0607 69.1818 67.394 68.5757 68.4849C67.9697 69.5758 66.5151 69.697 65.4242 69.091L63.9697 68.0001C64.9394 68.7273 65.1818 70.0607 64.5757 71.1516C63.8485 72.1213 62.5151 72.3637 61.4242 71.7576L59.9697 70.788M59.9697 70.788L56.697 68.4849L59.8485 70.6667C59.8485 70.6667 59.9697 70.6667 59.9697 70.788ZM59.9697 70.788C60.9394 71.5152 61.0606 72.8486 60.4545 73.8183C59.7273 74.788 58.3939 75.0304 57.303 74.4243L55.8485 73.3334M49.303 75.5152L50.3939 74.5455C51.2424 73.697 51.3636 72.2425 50.5151 71.394C49.6667 70.5455 48.2121 70.4243 47.3636 71.2728L46.2727 72.2425C45.4242 73.091 45.303 74.4243 46.1515 75.394C47 76.3637 48.4545 76.4849 49.303 75.5152Z",
    stroke: "url(#paint4_linear_631_2659)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1515 74.7882L53.1818 76.8488C54.1515 77.5761 55.6061 77.3337 56.3334 76.2428C57.0606 75.2731 56.8182 73.8185 55.7273 73.0912L54.0303 71.8791M36.4546 63.0306C35.8485 62.5458 35.3637 61.9397 34.8788 61.3337L32.9394 58.0609L40.4546 47.3943L43.1212 49.3337C44.0909 50.0609 48.4546 51.1518 49.6667 50.9094M27.4849 55.8791L32.0909 59.1518L41.303 45.9397L36.697 42.667M59.1212 64.6064L63.8485 68.0003",
    stroke: "url(#paint5_linear_631_2659)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8788 64.3639C67.3636 60.9699 69.1818 59.879 70.2727 58.6669C71.1212 57.8184 72.9394 54.6669 72.9394 54.6669L63.7272 44.2427L61.4242 46.3033C60.4545 47.1518 59.3636 47.6366 58.1515 47.7578L54.1515 48.1215C52.6969 48.2427 51.2424 48.9699 50.3939 50.0609L46.0303 55.1518C48.0909 56.9699 51.2424 56.7275 53.0606 54.6669L55.2424 52.3639",
    stroke: "url(#paint6_linear_631_2659)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9091 52.1213L73.6667 55.6365L62.7576 43.2728L67 39.8789",
    stroke: "url(#paint7_linear_631_2659)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_631_2659",
    x1: 2.75783,
    y1: 37.3943,
    x2: 55.4848,
    y2: 37.3943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_631_2659",
    x1: 7.72756,
    y1: 42.425,
    x2: 60.5758,
    y2: 42.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_631_2659",
    x1: 7.72738,
    y1: 16.2428,
    x2: 25.3031,
    y2: 16.2428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_631_2659",
    x1: 35.6331,
    y1: 66.9307,
    x2: 48.6698,
    y2: 66.9307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_631_2659",
    x1: 45.5726,
    y1: 65.3047,
    x2: 68.9062,
    y2: 65.3047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_631_2659",
    x1: 27.485,
    y1: 59.966,
    x2: 63.8485,
    y2: 59.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_631_2659",
    x1: 46.0304,
    y1: 54.3034,
    x2: 72.9394,
    y2: 54.3034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_631_2659",
    x1: 62.7576,
    y1: 47.7578,
    x2: 77.9091,
    y2: 47.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrity);
export default __webpack_public_path__ + "static/media/Integrity.b1914899e03f90dce491a0767cd04ac3.svg";
export { ForwardRef as ReactComponent };